/* Banco de temas do dia de "A Hora do Inconsciente".
   Cada entrada segue o shape:
   { titulo, definicao, exemplo, casoResumo, casoCompleto[], video: { url }, quiz, referenciaLivro: { titulo, autor } }
   video.url: link direto do vídeo específico do tema, se existir; se null, a tela usa o canal do
   YouTube do Instituto como destino genérico (hoje o card de vídeo da trilha é sempre genérico —
   o campo fica pronto para uso futuro, caso vídeos por tema sejam produzidos).
   referenciaLivro: livro de origem do conceito, exibido como referência bibliográfica no card.

   As entradas reais vêm de um arquivo por autor (conceitos-<autor>.js, extraídos e adaptados dos
   livros da série "A Psicanálise em 20 Frases", de William Marcos da Silva) e são intercaladas
   abaixo para que a rotação diária não agrupe vários dias seguidos do mesmo livro/autor. */

import { CONCEITOS_FREUD } from "./conceitos-freud";
import { CONCEITOS_LACAN } from "./conceitos-lacan";
import { CONCEITOS_KLEIN } from "./conceitos-klein";
import { CONCEITOS_WINNICOTT } from "./conceitos-winnicott";
import { CONCEITOS_JUNG } from "./conceitos-jung";
import { CONCEITOS_FERENCZI } from "./conceitos-ferenczi";

function intercalar(...bancos) {
  const maxLen = Math.max(...bancos.map((b) => b.length));
  const resultado = [];
  for (let i = 0; i < maxLen; i++) {
    for (const banco of bancos) {
      if (banco[i]) resultado.push(banco[i]);
    }
  }
  return resultado;
}

export const CONCEITOS_BANCO = intercalar(
  CONCEITOS_FREUD,
  CONCEITOS_LACAN,
  CONCEITOS_KLEIN,
  CONCEITOS_WINNICOTT,
  CONCEITOS_JUNG,
  CONCEITOS_FERENCZI
);

const CANAL_YOUTUBE_PADRAO = "https://www.youtube.com/@institutointernacionalpsicanal";
const NOTA_AMAZON_IDIOMAS = "disponível na Amazon, traduzido em 4 idiomas (português, inglês, espanhol e francês)";

/* Recurso de TESTE, ativo somente em ambiente de desenvolvimento (`npm start`, NODE_ENV
   "development") — nunca compilado ativo em `npm run build` (NODE_ENV "production"), então não
   tem efeito em produção mesmo que alguém tente a URL manualmente. Não é exposto em nenhuma
   interface. Permite simular outra data via ?data=AAAA-MM-DD na URL, só para inspecionar a
   rotação dos 108 conceitos sem esperar dias reais passarem. */
function dataDeTesteViaUrl() {
  if (process.env.NODE_ENV !== "development") return null;
  if (typeof window === "undefined") return null;
  const valor = new URLSearchParams(window.location.search).get("data");
  if (!valor || !/^\d{4}-\d{2}-\d{2}$/.test(valor)) return null;
  const [ano, mes, dia] = valor.split("-").map(Number);
  const data = new Date(ano, mes - 1, dia);
  return Number.isNaN(data.getTime()) ? null : data;
}

export function getConceitoDoDia(data = new Date()) {
  if (!CONCEITOS_BANCO.length) return null;
  const dataEfetiva = dataDeTesteViaUrl() || data;
  const diasDesdeEpoca = Math.floor(
    Date.UTC(dataEfetiva.getFullYear(), dataEfetiva.getMonth(), dataEfetiva.getDate()) / 86400000
  );
  // Ciclo fechado: ao passar da última entrada, o módulo reinicia do índice 0 — o banco de 108
  // conceitos se repete indefinidamente e não cresce sozinho.
  const indice = ((diasDesdeEpoca % CONCEITOS_BANCO.length) + CONCEITOS_BANCO.length) % CONCEITOS_BANCO.length;
  return CONCEITOS_BANCO[indice];
}

export function getVideoUrl(conceito) {
  return conceito?.video?.url || CANAL_YOUTUBE_PADRAO;
}

export function getReferenciaTexto(conceito) {
  const ref = conceito?.referenciaLivro;
  if (!ref) return null;
  return `${ref.titulo} — ${ref.autor}, ${NOTA_AMAZON_IDIOMAS}`;
}
